import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import DownloadCTA from './components/DownloadCTA';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import useHashRoute from './hooks/useHashRoute';
import './App.css';

function App() {
  const route = useHashRoute();
  const isPrivacy = route === '/privacy';

  // Start legal pages at the top rather than mid-scroll.
  useEffect(() => {
    if (isPrivacy) window.scrollTo(0, 0);
  }, [isPrivacy]);

  if (isPrivacy) {
    return <PrivacyPolicy />;
  }

  return (
    <div className="app">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <DownloadCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
